import { render, staticRenderFns } from "./item-title.vue?vue&type=template&id=3ae22be6&scoped=true&"
import script from "./item-title.vue?vue&type=script&lang=ts&"
export * from "./item-title.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae22be6",
  null
  
)

export default component.exports